import { Component, Input, OnInit } from '@angular/core'

import { Incentive } from '../../shared/interfaces/resources/incentive.interface'
import { FavoriteService } from '../../shared/services/favorite.service'

@Component({
  selector: 'app-favorite-button',
  templateUrl: './favorite-button.component.html',
  styleUrls: ['./favorite-button.component.scss']
})
export class FavoriteButtonComponent implements OnInit {
  @Input() incentive: Incentive
  @Input() compact: boolean

  isFavorite: boolean
  tooltipContent: string

  constructor(private favoriteService: FavoriteService) {}

  ngOnInit(): void {
    this.tooltipContent = this.getTooltipContent()
    this.isFavorite = this.favoriteService.isFavorite(this.incentive)

    this.favoriteService.favoriteIncentives.subscribe((incentives) => {
      this.isFavorite = this.favoriteService.isFavorite(this.incentive)
    })
  }

  toggleFavorite(incentive: Incentive) {
    this.isFavorite = this.favoriteService.toggle(incentive)
    this.tooltipContent = this.getTooltipContent()
  }

  getTooltipContent() {
    if (!this.compact) {
      return null
    }

    return this.isFavorite ? 'Remove from comparison' : 'Add to comparison'
  }
}
